const BASE_API_URL = process.env.NODE_ENV === 'production' ? 'https://financialaid.iastate.edu/expense-api/v2/' : 'http://127.0.0.1:4000/api/'
const HEADERS_JSON = {
  'Content-Type': 'application/json charset=utf-8',
}


function api(path) {
  const p = path || ''
  return BASE_API_URL + p
}

function queryString(params) {
  return Object.entries(params).map( ([k, v], i) => `${k}=${encodeURIComponent(v)}`)
    .join('&')
} 

function request(url, signal, method, data, params, headers = HEADERS_JSON) {
    if(params) url+= `?${queryString(params)}`
    const body = data instanceof FormData ? data : JSON.stringify(data)
    return fetch(url, {
      method,
      body,
      signal,
      headers,
    })
}

export {
    api, request,
}